module.exports = __webpack_public_path__ + "img/nossel.59860c23.png";